import {
  KnowledgeBaseDocumentCreateModel,
  KnowledgeBaseDocumentDetailedModel,
  KnowledgeBaseDocumentListModel,
  KnowledgeBaseDocumentRecordModel,
  KnowledgeBaseDocumentTypeModel,
} from "@/api/models/knowledge-bases/documents";
import {
  FetchKnowledgeBaseItems200AllOf,
  KnowledgeBaseItem,
} from "@/api/services";
import {datesTransform} from "@/api/transform/common";
import {ManagementTransformBase} from "@/api/transform/TranformBase";

export class KnowledgeBaseDocumentsTransform extends ManagementTransformBase<KnowledgeBaseDocumentRecordModel> {
  public makeRecordModel(
    dto: KnowledgeBaseItem,
  ): KnowledgeBaseDocumentRecordModel {
    const model: KnowledgeBaseDocumentRecordModel = {
      ...datesTransform.makeTimestampsModel({created_at: dto.created}),
      slug: dto.slug,
      name: dto.name,
      type: dto.type as KnowledgeBaseDocumentTypeModel,
      url: dto.url,
    };

    return model;
  }

  public makeListModel(
    dto: FetchKnowledgeBaseItems200AllOf,
  ): KnowledgeBaseDocumentListModel {
    const model: KnowledgeBaseDocumentListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as KnowledgeBaseItem),
      ),
      // TODO: ask backend to add pagination.
      // pagination: this.makePaginationModel(dto),
      pagination: {
        current: 1,
        size: 50,
        pagesCount: 1,
        totalCount: 50,
      },
    };

    return model;
  }

  public makeCreateDto(model: KnowledgeBaseDocumentCreateModel): {
    slug: string;
    data: KnowledgeBaseItem;
  } {
    const dto: KnowledgeBaseItem = {
      name: model.data.name,
      type: model.data.type,
    };

    if (model.data.url) {
      dto.url = model.data.url;
    }

    if (model.data.content) {
      dto.text = model.data.content;
    }

    return {slug: model.slug, data: dto};
  }

  public makeDetailsModel(
    dto: KnowledgeBaseItem,
  ): KnowledgeBaseDocumentDetailedModel {
    return {
      ...this.makeRecordModel(dto),
      text: dto.text,
    };
  }
}

export const knowledgeBaseDocumentsTransform =
  new KnowledgeBaseDocumentsTransform();
